import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
export default class ComponentDoc extends PureComponent {
    render() {
        const { name, demoName, propInfos, remarks, children } = this.props;
        return (React.createElement("div", null,
            React.createElement("div", { className: "row", style: { paddingBottom: '10px' } },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement("h2", null, name),
                    propInfos.length ? React.createElement(PropsTable, { propInfos: propInfos }) : null,
                    React.createElement("div", null, remarks))),
            children ? (React.createElement("div", { className: "row", style: { paddingBottom: '30px' } },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement("h3", null, demoName),
                    children))) : null));
    }
}
ComponentDoc.propTypes = {
    name: PropTypes.string.isRequired,
    demoName: PropTypes.string,
    propInfos: PropTypes.arrayOf(PropTypes.node),
    remarks: PropTypes.element,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};
ComponentDoc.defaultProps = {
    propInfos: [],
    demoName: 'Demo',
};
